import { render, staticRenderFns } from "./SampleRecord.vue?vue&type=template&id=76fd1d50&scoped=true"
import script from "./SampleRecord.vue?vue&type=script&lang=js"
export * from "./SampleRecord.vue?vue&type=script&lang=js"
import style0 from "./SampleRecord.vue?vue&type=style&index=0&id=76fd1d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd1d50",
  null
  
)

export default component.exports